// extracted by mini-css-extract-plugin
export default {"coordinates-metrics":"coordinates-metrics_coordinates-metrics__Wl756","coordinates-metrics-popup":"coordinates-metrics_coordinates-metrics-popup__Uwjkz"};